import EAIcon from "components/common/EAIcon";
import { getEsgScoresColor } from "services/common/DataBlocksUtils";
import useStyles from "./ClassificationEsgScoreStyle";

const ClassificationEsgScore = ({score, esgDetailsContent}) => {

  const {classes} = useStyles();

  return (
      <div className={classes.score_flex}>
        <div className={classes.score_bold}>{score}</div>
        <div className={classes.rectangles_scores}>
            <div className={score === "1" ? classes.actif : undefined}> 
              <span className={classes.rectangle_score} style={{backgroundColor: getEsgScoresColor(1), opacity: score === "1" ? 1 : 0.2}}>
                <EAIcon icon="check_circle" style={{display: score === "1" ? "unset": "none"}} className={classes.rectangle_score_logo} />
              </span>
              <div className={classes.rectangle_score_libelle} style={{display: score === "1" ? "unset": "none"}}>{esgDetailsContent["score_very_good"]}</div>
            </div>
            <div className={score === "2" ? classes.actif : undefined}>
              <span className={classes.rectangle_score} style={{backgroundColor: getEsgScoresColor(2), opacity: score === "2" ? 1 : 0.2}}>
                <EAIcon icon="check_circle" style={{display: score === "2" ? "unset": "none"}} className={classes.rectangle_score_logo} />
              </span>
              <div className={classes.rectangle_score_libelle} style={{display: score === "2" ? "unset": "none"}}>{esgDetailsContent["score_good"]}</div>
            </div>
            <div className={score === "3" ? classes.actif : undefined}>
              <span className={classes.rectangle_score} style={{backgroundColor: getEsgScoresColor(3), opacity: score === "3" ? 1 : 0.2}}>
                <EAIcon icon="check_circle" style={{display: score === "3" ? "unset": "none"}} className={classes.rectangle_score_logo} />
              </span>
              <div className={classes.rectangle_score_libelle} style={{display: score === "3" ? "unset": "none"}}>{esgDetailsContent["score_medium"]}</div>
            </div>
            <div className={score === "4" ? classes.actif : undefined}>
              <span className={classes.rectangle_score} style={{backgroundColor: getEsgScoresColor(4), opacity: score === "4" ? 1 : 0.2}}>
                <EAIcon icon="check_circle" style={{display: score === "4" ? "unset": "none"}} className={classes.rectangle_score_logo} />
              </span>
              <div className={classes.rectangle_score_libelle} style={{display: score === "4" ? "unset": "none"}}>{esgDetailsContent["score_poor"]}</div>
            </div>
            <div className={score === "5" ? classes.actif : undefined}>
              <span className={classes.rectangle_score} style={{backgroundColor: getEsgScoresColor(5), opacity: score === "5" ? 1 : 0.2}}>
                <EAIcon icon="check_circle" style={{display: score === "5" ? "unset": "none"}} className={classes.rectangle_score_logo} />
              </span>
              <div className={classes.rectangle_score_libelle} style={{display: score === "5" ? "unset": "none"}}>{esgDetailsContent["score_very_poor"]}</div>
            </div>
        </div>
    </div>
  )
}
export default ClassificationEsgScore;